"use client";
import SpotTradingForm from "./spot";
import FuturesTradingForm from "./futures";
import StocksTradingForm from "./stocks";

interface TradingFormPanelProps {
  symbol?: string;
  isEco?: boolean;
  onOrderSubmit?: (orderData: any) => Promise<any>;
  isFutures?: boolean;
  marketType?: "spot" | "futures" | "stocks";
  isStocks?: boolean;
}

export default function TradingFormPanel({
  symbol = "btc/usdt",
  isEco = false,
  onOrderSubmit,
  isFutures = false,
  marketType = "spot",
  isStocks = false,
}: TradingFormPanelProps) {
  return (
    <div className="h-full">
      {marketType === "futures" ? (
        <FuturesTradingForm symbol={symbol} onOrderSubmit={onOrderSubmit} />
      ) : marketType === "stocks" ? (
        <StocksTradingForm symbol={symbol} onOrderSubmit={onOrderSubmit} />
      ) : (
        <SpotTradingForm
          symbol={symbol}
          isEco={isEco}
          onOrderSubmit={onOrderSubmit}
        />
      )}
    </div>
  );
}
